import React from 'react';
import PropTypes from 'prop-types';
import { getResourceTo } from 'react/utils/utils';
import Loading from 'react/components/Loading';
import resources from './resources';

import TicketList from './TicketList';

function TicketHubList(props) {
  const {
    tickets,
    isLoading
  } = props;

  return (
    <div className="ticketHub__list">
      <div className="ticketHub__list-title">
        {getResourceTo(resources.ticketListTitle)}
      </div>
      {
        isLoading
          ? <Loading />
          : <TicketList tickets={tickets} />
      }
    </div>
  );
}

TicketHubList.propTypes = {
  tickets: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired
};

export default TicketHubList;
